import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { ClusterList_clusters_edges_node } from "@saleor/cluster/types/ClusterList";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import ClusterList from "../ClusterList";
import { ClusterFilterKeys, ClusterListUrlFiltersOpts } from "./filters";

export interface ClusterTableProps
  extends PageListProps,
    TabPageProps,
    ListActions,
    FilterPageProps<ClusterFilterKeys, ClusterListUrlFiltersOpts> {
  clusters: ClusterList_clusters_edges_node[];
}

export const ClusterListPage: React.FC<ClusterTableProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  currencySymbol,
  onAdd,
  ...listProps
}) => {
  const intl = useIntl();

  const breadcrumbDirectory = [
    {
      name: "Clusters"
    }
  ];

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.cluster)}>
        <Button
          color="primary"
          variant="contained"
          onClick={onAdd}
          id="createClusterBtn"
        >
          <FormattedMessage
            defaultMessage="Create cluster"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          tabs={tabs}
          filterStructure={[]}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Clusters"
          })}
          initialSearch={initialSearch}
          onSearchChange={onSearchChange}
          onFilterChange={onFilterChange}
          onAll={onAll}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <ClusterList {...listProps} />
      </Card>
    </Container>
  );
};
ClusterListPage.displayName = "ClusterListPage";
export default ClusterListPage;
